import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ManagementVoyageModel } from '@data-layer/models/management';
import { UntypedFormGroup } from '@angular/forms';
import { CodeRepository, ContainerFreightStoragesRepository } from '@data-layer/repositories';
import { FormHelper } from '@helpers/form.helper';
import { CUSTOM_MASK } from '@helpers/custom-validator';
import { IDefaultSelect } from '@interfaces/default-select';
import { enumPublishingState, enumVoyageStatus } from '@data-layer/enums/lcl';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'voyage-edit',
  templateUrl: './voyage-edit.component.html',
  styleUrls: ['./voyage-edit.component.scss'],
})
export class VoyageEditComponent implements OnChanges {
  @Input() public voyage: ManagementVoyageModel;
  @Input() public formGroup: UntypedFormGroup;

  public errors = {
    required: 'FORM_ERROR.REQUIRED',
    maxlength: 'FORM_ERROR.MAX_LENGTH',
    pattern: 'FORM_ERROR.LOGIN_EMAIL',
    validatePhoneNumber: 'FORM_ERROR.PHONE_NUMBER',
  };
  public CUSTOM_MASK = CUSTOM_MASK;

  public statusSelect: IDefaultSelect[] = [];
  public publishingStateSelect: IDefaultSelect[] = [];

  constructor(
    private codeRepository: CodeRepository,
    private fh: FormHelper,
    private translateService: TranslateService,
    private containerFreightStoragesRepository: ContainerFreightStoragesRepository,
  ) {
    this.getStatusSelect();
    this.getPublishingStateSelect();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (!!changes.voyage.currentValue && !!this.formGroup) {
      this.formGroup.reset();
      this.formGroup.patchValue(this.voyage);
    }

    if (changes.formGroup && !this.formGroup) {
      this.formGroup = this.fh.createVoyageFormGroup();
    }
  }

  private getStatusSelect() {
    forkJoin(
      [enumVoyageStatus.DRAFT, enumVoyageStatus.PUBLISHED, enumVoyageStatus.LOADED, enumVoyageStatus.IN_TRANSIT].map((status) =>
        this.translateService.get('VOYAGE_STATUS.' + enumVoyageStatus[status]).pipe(map((label) => ({ label, value: status }))),
      ),
    )
      .pipe(take(1))
      .subscribe((select) => (this.statusSelect = select));
  }

  private getPublishingStateSelect() {
    this.publishingStateSelect = Object.keys(enumPublishingState)
      .filter((item) => Number(item) > -1)
      .map((item: any) => ({
        id: item,
        label: this.translateService.instant('PUBLISHING_STATE.' + enumPublishingState[item]),
        value: Number(item),
      }));
  }
}
